// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// TODO [IM] IMPORTANT: variables copied from Oregon(stage), later should be updated to N.Virginia(dev)

export const environment = {
  production: false,
  version: '3.11.0',
  customDomainURL: 'https://api-chatbot-stg.omantel.om/',
  ceServerURL: 'https://2nqb1rhctc.execute-api.us-west-2.amazonaws.com/stage/',
  chatbots: [{
      Id : 'd26e9480-c4ae-11ee-a426-592db33f2e90',
      language : 'en'
    },
    {
      Id : 'd42c20d0-8c1f-11ed-bef1-43f19b3020c2',
      language : 'ar'
    }],
  webSocketURL: 'wss://kihvam7ny2.execute-api.us-west-2.amazonaws.com/stage',
  alias: 'omantel-ecare-stage'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
